import { theme } from 'antd';
import React, { useState } from 'react';
import { Row, Typography } from 'zui/Antd';

const { Text } = Typography;

const ViewMoreToggle = ({ data, maxItemsToShow = 4, onToggle }) => {
	const {
		token: { marginXS, colorPrimary }
	} = theme.useToken();

	const [showAll, setShowAll] = useState(false);

	const handleToggle = () => {
		setShowAll((prevState) => !prevState);
		if (onToggle) onToggle(!showAll);
	};

	return (
		data?.length > maxItemsToShow && (
			<Row justify='end' style={{ marginTop: marginXS }}>
				<Text strong style={{ cursor: 'pointer', color: colorPrimary }} onClick={handleToggle}>
					{showAll ? 'View Less' : 'View More'}
				</Text>
			</Row>
		)
	);
};

export default ViewMoreToggle;
